<template>
    <div class="p-grid">
        <div class="p-lg-4 p-sm-6 p-col-12">
            <CustomInputText name="name" label="Nazwa" v-model="internalValue.name"/>
        </div>
        <div class="p-col-4">
        </div>
    </div>
</template>

<script>
    import CustomInputText from "../../../components/form/CustomInputText";

    export default {
        name: "CollectionSearchCriteria",

        props: {
            modelValue: null,
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        components: {CustomInputText},
    };
</script>

<style lang="less" scoped>

</style>
